import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Button, { LoadingButton } from 'beam/dist/Button'
import TextField from 'beam/dist/TextField'
import withStyles from 'beam/dist/styles'

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(1),
    '& > *': {
      marginLeft: theme.spacing(1),
    },
  },
  buttonProgress: {
    color: theme.palette.common.white,
  },
})

class AppealForm extends PureComponent {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSubmitAppeal: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  }

  state = {
    reasonText: '',
    reasonValid: true,
    submitButtonLoading: false,
  }

  handleReasonChange = event => {
    this.setState({
      reasonText: event.target.value,
      reasonValid: event.target.value.length <= 3000,
    })
  }

  handleCancel = () => {
    const { onCancel } = this.props

    onCancel()
  }

  handleSubmit = () => {
    const { onSubmitAppeal } = this.props
    const { reasonText } = this.state

    this.setState({
      submitButtonLoading: true,
    })

    onSubmitAppeal(reasonText)
  }

  render() {
    const { classes, t } = this.props
    const { reasonText, reasonValid, submitButtonLoading } = this.state

    return (
      <form className={classes.root}>
        <TextField
          label={t(['provideReasonForAppeal', 'Provide reason for appeal'])}
          placeholder={t(['addReason', 'Add Reason'])}
          multiline
          fullWidth
          maxRows={'40'}
          value={reasonText}
          onChange={this.handleReasonChange}
          margin="dense"
          error={!reasonValid}
          helperText={reasonValid ? `${3000 - reasonText.length} ${t('charactersRemaining')}` : t('maximumCharLimit')}
        />
        <div className={classes.buttons}>
          <Button size="small" onClick={this.handleCancel}>
            {t('cancel')}
          </Button>
          <LoadingButton
            size="small"
            color="primary"
            variant="contained"
            onClick={this.handleSubmit}
            loading={submitButtonLoading}
            classes={{ buttonProgress: classes.buttonProgress }}
          >
            {t(['appeal', 'Appeal'])}
          </LoadingButton>
        </div>
      </form>
    )
  }
}

export default withStyles(styles)(withTranslation()(AppealForm))
